"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOWER_BREAK_POINTS = exports.BREAK_POINTS = void 0;
var BREAK_POINTS;

(function (BREAK_POINTS) {
  BREAK_POINTS[BREAK_POINTS["xxs"] = 342] = "xxs";
  BREAK_POINTS[BREAK_POINTS["xs"] = 575] = "xs";
  BREAK_POINTS[BREAK_POINTS["sm"] = 767] = "sm";
  BREAK_POINTS[BREAK_POINTS["md"] = 991] = "md";
  BREAK_POINTS[BREAK_POINTS["lg"] = 1199] = "lg";
})(BREAK_POINTS = exports.BREAK_POINTS || (exports.BREAK_POINTS = {}));

var LOWER_BREAK_POINTS;

(function (LOWER_BREAK_POINTS) {
  LOWER_BREAK_POINTS[LOWER_BREAK_POINTS["xxs"] = 0] = "xxs";
  LOWER_BREAK_POINTS[LOWER_BREAK_POINTS["xs"] = 343] = "xs";
  LOWER_BREAK_POINTS[LOWER_BREAK_POINTS["sm"] = 576] = "sm";
  LOWER_BREAK_POINTS[LOWER_BREAK_POINTS["md"] = 768] = "md";
  LOWER_BREAK_POINTS[LOWER_BREAK_POINTS["lg"] = 992] = "lg";
})(LOWER_BREAK_POINTS = exports.LOWER_BREAK_POINTS || (exports.LOWER_BREAK_POINTS = {}));